'use client';

import { T } from '@flipster/i18n';
import { Button } from '@flipster/react/design-system/button';
import PhishingIcon from '@flipster/react/icon/generated/PhishingIcon';
import { css } from '@flipster/styled-system/css';
import { hstack, stack, vstack } from '@flipster/styled-system/patterns';

export const ReportBanner = () => {
  return (
    <div
      className={css({
        gap: 16,
        p: 24,
        rounded: 16,
        bg: 'background.default.level-1',
        color: 'content.default.level-5',
        tabletDown: vstack.raw({ textAlign: 'center' }),
        tablet: hstack.raw(),
      })}
    >
      <PhishingIcon size={40} />
      <div className={stack({ gap: 8, tablet: { flex: 1 } })}>
        <p className={css({ textStyle: 'Title/XS' })}>
          <T id='VIP.r260316.Report_phishing_attacks' />
        </p>
        <p className={css({ textStyle: 'Text/L/Regular', color: 'content.default.level-3' })}>
          <T id='VIP.r260316.If_you_are_contacted_by_a_suspicious_source_please_report_it_immediately' />
        </p>
      </div>
      <Button
        as='a'
        href='/channel-verification/report'
        hierarchy='primary'
        color='accent'
        size='medium'
        label={<T id='VIP.r260316.Report_button' />}
        css={{ flexShrink: 0, tabletDown: { w: '100%', mt: 12 } }}
      />
    </div>
  );
};
